// @flow
import type {
  CreateBrowserSession,
  GetBrowserSession,
} from '../../core/browserSession';

import * as r from 'ramda';

export type GetSessionId = () => string;

export const getSessionId = (
  getBrowserSession: GetBrowserSession,
  createBrowserSession: CreateBrowserSession,
) => () => r.when(
  r.isNil,
  createBrowserSession,
)(getBrowserSession());

export default null;
